<template>
  <div class="main-wrapper services-page innerpagebg">
    <layouts-header></layouts-header>
    <breadcrumb :title="title" :text="text" :text1="text1" />
    <div class="content">
      <div class="container">
        <section class="services">
          <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="pills-all-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-all"
                type="button"
                role="tab"
                aria-controls="pills-all"
                aria-selected="true"
              >
                All Services
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="pills-coaching-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-coaching"
                type="button"
                role="tab"
                aria-controls="pills-coaching"
                aria-selected="false"
              >
                Coaching
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="pills-lessons-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-lessons"
                type="button"
                role="tab"
                aria-controls="pills-lessons"
                aria-selected="false"
              >
                Lessons
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="pills-coaches-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-coaches"
                type="button"
                role="tab"
                aria-controls="pills-coaches"
                aria-selected="false"
              >
                Coaches
              </button>
            </li>
          </ul>
          <div class="tab-content" id="pills-tabContent">
            <div
              class="tab-pane fade show active"
              id="pills-all"
              role="tabpanel"
              aria-labelledby="pills-all-tab"
            >
              <allservices></allservices>
            </div>
            <div
              class="tab-pane fade"
              id="pills-coaching"
              role="tabpanel"
              aria-labelledby="pills-coaching-tab"
            >
              <coaching></coaching>
            </div>
            <div
              class="tab-pane fade"
              id="pills-lessons"
              role="tabpanel"
              aria-labelledby="pills-lessons-tab"
            >
              <lesson></lesson>
            </div>
            <div
              class="tab-pane fade"
              id="pills-coaches"
              role="tabpanel"
              aria-labelledby="pills-coaches-tab"
            >
              <coaches></coaches>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
  <layout-footer></layout-footer>
</template>
<script>
export default {
  data() {
    return {
      title: "Services",
      text: "Home",
      text1: "Services",
    };
  },
};
</script>
